import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';

export class MyNgbDateParserFormatter extends NgbDateParserFormatter {
	datePipe = new DatePipe('en-US');
	constructor(
		private dateFormatString: string) {
		super();
	}
	format(date: NgbDateStruct): string {
		if (date === null) {
			return '';
		}
		try {

			return this.datePipe.transform(new Date(date.year, date.month - 1, date.day), this.dateFormatString);
		} catch (e) {
			return '';
		}
	}
	parse(value: string): NgbDateStruct {

		let returnVal: NgbDateStruct;
		if (!value) {
			returnVal = null;
		} else {
			try {
				if (this.dateFormatValidator(value)) {

					let dateParts = this.datePipe.transform(value, 'MM-dd-yyyy').split('-');
					returnVal = { year: parseInt(dateParts[2]), month: parseInt(dateParts[0]), day: parseInt(dateParts[1]) };
				} else {

					returnVal = null;
				}

			} catch (e) {
				returnVal = null;
			}
		}
		return returnVal;
	}

	dateFormatValidator(evt) {

		let date: any;
		let userPrefRegFormat: any;
		let userPrefFormatDelimeter: any;
		if (this.dateFormatString.indexOf('-') !== -1) {
			userPrefFormatDelimeter = '-';
			if (this.dateFormatString === 'MM-dd-yyyy') {
				userPrefRegFormat = /^(\d{2}|\d{1})[-\/](\d{2}|\d{1})[-\/](\d{4})$/;
			} else if (this.dateFormatString === 'dd-MM-yyyy') {
				userPrefRegFormat = /^(\d{2}|\d{1})[-\/](\d{2}|\d{1})[-\/](\d{4})$/;
			} else {
				userPrefRegFormat = /^(\d{4})[-\/](\d{2}|\d{1})[-\/](\d{2}|\d{1})$/;
			}

		} else if (this.dateFormatString.indexOf('.') !== -1) {
			userPrefFormatDelimeter = '.';
			if (this.dateFormatString === 'MM.dd.yyyy') {
				userPrefRegFormat = /^(\d{2}|\d{1})[.\/](\d{2}|\d{1})[.\/](\d{4})$/;
			} else if (this.dateFormatString === 'dd.MM.yyyy') {
				userPrefRegFormat = /^(\d{2}|\d{1})[.\/](\d{2}|\d{1})[.\/](\d{4})$/;
			} else {
				userPrefRegFormat = /^(\d{4})[.\/](\d{2}|\d{1})[.\/](\d{2}|\d{1})$/;
			}

		} else {
			userPrefFormatDelimeter = '/';
			if (this.dateFormatString === 'dd/MM/yyyy') {
				userPrefRegFormat = /^(\d{2}|\d{1})[/\/](\d{2}|\d{1})[/\/](\d{4})$/;
			} else if (this.dateFormatString === 'MM/dd/yyyy') {
				userPrefRegFormat = /^(\d{2}|\d{1})[/\/](\d{2}|\d{1})[/\/](\d{4})$/;
			} else {
				userPrefRegFormat = /^(\d{4})[/\/](\d{2}|\d{1})[/\/](\d{2}|\d{1})$/;
			}
		};
		if (typeof (evt) == "string") {

			let matchesngb = userPrefRegFormat.exec(evt); ///^(\d{4})[-\/](\d{2}|\d{1})[-\/](\d{2}|\d{1})$/.exec(evt);
			if (matchesngb == null) {
				return false;
			}

			let year: number;
			let month: number;
			let day: number;
			if (this.dateFormatString === 'dd/MM/yyyy') {
				year = parseInt(matchesngb[3]);
				month = parseInt(matchesngb[2]);
				day = parseInt(matchesngb[1]);
			} else if (this.dateFormatString === 'yyyy/MM/dd') {
				year = parseInt(matchesngb[1]);
				month = parseInt(matchesngb[2]);
				day = parseInt(matchesngb[3]);
			} else if (this.dateFormatString === 'MM-dd-yyyy') {
				year = parseInt(matchesngb[3]);
				month = parseInt(matchesngb[1]);
				day = parseInt(matchesngb[2]);
			} else if (this.dateFormatString === 'dd-MM-yyyy') {
				year = parseInt(matchesngb[3]);
				month = parseInt(matchesngb[2]);
				day = parseInt(matchesngb[1]);
			} else if (this.dateFormatString === 'yyyy-MM-dd') {
				year = parseInt(matchesngb[1]);
				month = parseInt(matchesngb[2]);
				day = parseInt(matchesngb[3]);
			} else if (this.dateFormatString === 'MM.dd.yyyy') {
				year = parseInt(matchesngb[3]);
				month = parseInt(matchesngb[1]);
				day = parseInt(matchesngb[2]);
			} else if (this.dateFormatString === 'dd.MM.yyyy') {
				year = parseInt(matchesngb[3]);
				month = parseInt(matchesngb[2]);
				day = parseInt(matchesngb[1]);
			} else if (this.dateFormatString === 'yyyy.MM.dd') {
				year = parseInt(matchesngb[1]);
				month = parseInt(matchesngb[2]);
				day = parseInt(matchesngb[3]);
			} else if (this.dateFormatString === 'MM/dd/yyyy') {
				year = parseInt(matchesngb[3]);
				month = parseInt(matchesngb[1]);
				day = parseInt(matchesngb[2]);
			}

			date = {
				'year': year,
				'month': month,
				'day': day
			}
		} else {

			const tempEvt = evt;
			if (tempEvt && !isNaN(tempEvt.day)) {

				let temp: any;
				if (this.dateFormatString === 'dd/MM/yyyy' || this.dateFormatString === 'dd-MM-yyyy' || this.dateFormatString === 'dd.MM.yyyy') {
					temp = evt.day + userPrefFormatDelimeter + tempEvt.month + userPrefFormatDelimeter + tempEvt.year;
				} else if (this.dateFormatString === 'yyyy/MM/dd' || this.dateFormatString === 'yyyy-MM-dd' || this.dateFormatString === 'yyyy.MM.dd') {
					temp = tempEvt.year + userPrefFormatDelimeter + tempEvt.month + userPrefFormatDelimeter + evt.day;
				} else if (this.dateFormatString === 'MM-dd-yyyy' || this.dateFormatString === 'MM.dd.yyyy' || this.dateFormatString === 'MM/dd/yyyy') {
					temp = tempEvt.month + userPrefFormatDelimeter + evt.day + userPrefFormatDelimeter + tempEvt.year;
				}

				let matchesNew = userPrefRegFormat.exec(temp);// /^(\d{4})[-\/](\d{2}|\d{1})[-\/](\d{2}|\d{1})$/.exec(temp);
				if (matchesNew == null) {

					return false;
				}
				date = evt;
			} else {
				return true;
			}
		}
		const tempDate = date;
		tempDate['month'] = date['month'] - 1;
		let composedDate = new Date(tempDate.year, tempDate.month, tempDate.day);
		return composedDate.getDate() == tempDate.day &&
			composedDate.getMonth() == tempDate.month &&
			composedDate.getFullYear() == tempDate.year;
	}
}